import styled from 'styled-components';

const Slogan = styled.h2`
  margin: 48px 0;
  font-size: 20px;
  font-weight: normal;
`;

export default Slogan;



// WEBPACK FOOTER //
// ./src/pages/Login/Slogan.js